module.exports = __webpack_public_path__ + "img/card_220320572.eb99ae16.png";